import React from 'react';
import styled, { css } from 'styled-components';
import { prop, ifProp } from 'styled-tools';
import { SCAFFOLDING } from 'theme';

const StyledMapWrapperGuidelines = styled.div`
    box-sizing: content-box;
    display: flex;
    flex-direction: column;
    position: relative;
    width: ${prop('width')};
    height: ${prop('height')};
    min-width: calc(100% - ${SCAFFOLDING.GUTTER_FACTOR(2)});
    min-height: calc(100% - ${SCAFFOLDING.GUTTER_FACTOR(2)});
    padding: ${SCAFFOLDING.GUTTER};

    ${ifProp(
        'active',
        css`
            &:before,
            &:after {
                content: '';
                position: absolute;
                z-index: ${SCAFFOLDING.Z_INDEX.indexOf('MapGuidelines')};
                background-color: #00ffff;
                pointer-events: none;
            }

            &:before {
                top: 0;
                bottom: 0;
                left: 50%;
                width: 1px;
            }

            &:after {
                top: 50%;
                right: 0;
                left: 0;
                height: 1px;
            }
        `
    )}
`;

// This component can't be a stateless function since it uses refs
// eslint-disable-next-line react/prefer-stateless-function
class MapWrapperGuidelines extends React.Component {
    render() {
        const { active, width, height, children, ...props } = this.props;
        return (
            <StyledMapWrapperGuidelines active={active} width={width} height={height} {...props}>
                {children}
            </StyledMapWrapperGuidelines>
        );
    }
}

export default MapWrapperGuidelines;
